// Config editor mock data.

export interface TreeSection {
  id: string;
  kind: 'section';
  name: string;
  num: string;
  expanded?: boolean;
}

export interface TreeRow {
  id: string;
  kind: 'row';
  parent: string;
  name: string;
  level: number;
  sources?: number;
  isTotal?: boolean;
  hasIssue?: boolean;
}

export type TreeNode = TreeSection | TreeRow;

export interface RowSource {
  file: string;
  cell: string;
  label: string;
  preview: number;
}

export interface ValidationRule {
  id: string;
  label: string;
  ok: boolean;
  msg?: string;
}

export interface RowDataItem {
  id: string;
  name: string;
  level: number;
  isTotal?: boolean;
  description: string;
  sources: RowSource[];
  masterMapping: { sheet: string; cell: string; label: string };
  preview: Record<string, number | null>;
  validationRules: ValidationRule[];
  usedIn: { id: string; name: string }[];
}

export interface CellPreview {
  file: string;
  sheet: string;
  cell: string;
  label: string;
  grid: string[][];
  hl: { r: number; c: number };
}

export const TREE: TreeNode[] = [
  { id: 's1', kind: 'section', name: 'СГД (главное)', expanded: true, num: '01' },
  { id: 'r1',  kind: 'row', parent: 's1', name: 'Доход от реализации товаров и услуг', level: 0, sources: 3 },
  { id: 'r1a', kind: 'row', parent: 's1', name: 'в т.ч. реализация продукции собственного производства', level: 1, sources: 1 },
  { id: 'r1b', kind: 'row', parent: 's1', name: 'в т.ч. перепродажа (импорт)', level: 1, sources: 1 },
  { id: 'r1c', kind: 'row', parent: 's1', name: 'в т.ч. прочие услуги', level: 1, sources: 1 },
  { id: 'r2',  kind: 'row', parent: 's1', name: 'Доход от прироста стоимости', level: 0, sources: 1 },
  { id: 'r3',  kind: 'row', parent: 's1', name: 'Прочие доходы', level: 0, sources: 2 },
  { id: 'r4',  kind: 'row', parent: 's1', name: 'ИТОГО СГД', level: 0, isTotal: true },
  { id: 'r5',  kind: 'row', parent: 's1', name: 'Себестоимость реализованных товаров и услуг', level: 0, sources: 3, hasIssue: true },
  { id: 'r6',  kind: 'row', parent: 's1', name: 'Валовая прибыль', level: 0, isTotal: true },

  { id: 's2', kind: 'section', name: 'Расшифровка адм. расходов · ТБ', num: '02' },
  { id: 'r7', kind: 'row', parent: 's2', name: 'Заработная плата АУП', level: 0, sources: 2 },
  { id: 'r8', kind: 'row', parent: 's2', name: 'Социальный налог и отчисления', level: 0, sources: 1 },
  { id: 'r9', kind: 'row', parent: 's2', name: 'Аренда офиса', level: 0, sources: 1 },

  { id: 's3', kind: 'section', name: 'Расшифровка адм. расходов · 1С', num: '03' },
];

export const ROW_DATA: Record<string, RowDataItem> = {
  r1: {
    id: 'r1', name: 'Доход от реализации товаров и услуг', level: 0,
    description: 'Выручка от основной деятельности по всем направлениям.',
    sources: [
      { file: '7211', cell: 'E175', label: 'Производство · реализация', preview: 124182000 },
      { file: '7211', cell: 'E176', label: 'Импорт · перепродажа',      preview: 38420000 },
      { file: '7211', cell: 'E177', label: 'Прочие услуги',             preview: 4118000 },
    ],
    masterMapping: { sheet: 'СГД', cell: 'B11', label: 'Доход от реализации' },
    preview: { dd: 166720000, sd: 142100000, kl: 88400000, ki: 102300000, dk: 71200000, cn: 44800000 },
    validationRules: [
      { id: 'nonneg', label: 'значение ≥ 0', ok: true },
      { id: 'within', label: 'отклонение от master ≤ 1%', ok: true },
      { id: 'sumcomp', label: 'сумма подстрок = строка', ok: true, msg: '166 720 000 = Σ(124 182 + 38 420 + 4 118)' },
    ],
    usedIn: [{ id: 'r4', name: 'ИТОГО СГД' }],
  },
  r1a: {
    id: 'r1a', name: 'в т.ч. реализация продукции собственного производства', level: 1,
    description: 'Подстрока r1. Производственная выручка ТБ.',
    sources: [{ file: '7211', cell: 'E175', label: 'Производство · реализация', preview: 124182000 }],
    masterMapping: { sheet: 'СГД', cell: 'B11.1', label: 'в т.ч. собственное произв-во' },
    preview: { dd: 124182000, sd: 110800000, kl: null, ki: null, dk: 56400000, cn: null },
    validationRules: [
      { id: 'nonneg', label: 'значение ≥ 0', ok: true },
      { id: 'within', label: 'отклонение от master ≤ 1%', ok: true },
    ],
    usedIn: [{ id: 'r1', name: 'Доход от реализации (родитель)' }],
  },
  r1b: {
    id: 'r1b', name: 'в т.ч. перепродажа (импорт)', level: 1,
    description: 'Подстрока r1. Импортная торговля.',
    sources: [{ file: '7211', cell: 'E176', label: 'Импорт · перепродажа', preview: 38420000 }],
    masterMapping: { sheet: 'СГД', cell: 'B11.2', label: 'в т.ч. перепродажа' },
    preview: { dd: 38420000, sd: 27300000, kl: 88400000, ki: 102300000, dk: 14800000, cn: null },
    validationRules: [
      { id: 'nonneg', label: 'значение ≥ 0', ok: true },
      { id: 'within', label: 'отклонение от master ≤ 1%', ok: true },
    ],
    usedIn: [{ id: 'r1', name: 'Доход от реализации (родитель)' }],
  },
  r1c: {
    id: 'r1c', name: 'в т.ч. прочие услуги', level: 1,
    description: 'Подстрока r1. Прочие услуги по основной деятельности.',
    sources: [{ file: '7211', cell: 'E177', label: 'Прочие услуги', preview: 4118000 }],
    masterMapping: { sheet: 'СГД', cell: 'B11.3', label: 'в т.ч. прочие услуги' },
    preview: { dd: 4118000, sd: 4000000, kl: null, ki: null, dk: null, cn: 44800000 },
    validationRules: [
      { id: 'nonneg', label: 'значение ≥ 0', ok: true },
      { id: 'within', label: 'отклонение от master ≤ 1%', ok: true },
    ],
    usedIn: [{ id: 'r1', name: 'Доход от реализации (родитель)' }],
  },
  r2: {
    id: 'r2', name: 'Доход от прироста стоимости', level: 0,
    description: 'Доход от переоценки активов.',
    sources: [{ file: 'osv', cell: 'F412', label: 'Переоценка ОС', preview: 1840000 }],
    masterMapping: { sheet: 'СГД', cell: 'B12', label: 'Доход от прироста стоимости' },
    preview: { dd: 1840000, sd: 0, kl: 0, ki: 0, dk: 0, cn: 0 },
    validationRules: [
      { id: 'nonneg', label: 'значение ≥ 0', ok: true },
      { id: 'within', label: 'отклонение от master ≤ 1%', ok: true },
    ],
    usedIn: [{ id: 'r4', name: 'ИТОГО СГД' }],
  },
  r3: {
    id: 'r3', name: 'Прочие доходы', level: 0,
    description: 'Курсовая разница и списание кредиторской задолженности.',
    sources: [
      { file: 'osv', cell: 'F438', label: 'Курсовая разница',                preview: 12420315 },
      { file: 'osv', cell: 'F441', label: 'Списание кредиторской задолжен.', preview: 2400000 },
    ],
    masterMapping: { sheet: 'СГД', cell: 'B14', label: 'Прочие доходы' },
    preview: { dd: 14820315, sd: 10320000, kl: 4000000, ki: 6000000, dk: 5000000, cn: 2200000 },
    validationRules: [
      { id: 'nonneg', label: 'значение ≥ 0', ok: true },
      { id: 'within', label: 'отклонение от master ≤ 1%', ok: false, msg: 'dd: 0.002% · ki: новая строка' },
    ],
    usedIn: [{ id: 'r4', name: 'ИТОГО СГД' }, { id: 'r6', name: 'Валовая прибыль' }],
  },
  r4: {
    id: 'r4', name: 'ИТОГО СГД', level: 0, isTotal: true,
    description: 'Итоговая строка. Сумма r1 + r2 + r3.',
    sources: [
      { file: '↩ ref', cell: 'r1', label: 'Доход от реализации товаров и услуг', preview: 166720000 },
      { file: '↩ ref', cell: 'r2', label: 'Доход от прироста стоимости',         preview: 1840000 },
      { file: '↩ ref', cell: 'r3', label: 'Прочие доходы',                        preview: 14820315 },
    ],
    masterMapping: { sheet: 'СГД', cell: 'B15', label: 'ИТОГО СГД' },
    preview: { dd: 183380315, sd: 156420000, kl: 92400000, ki: 108300000, dk: 76200000, cn: 47000000 },
    validationRules: [
      { id: 'sum', label: 'сумма компонентов = итог', ok: true },
      { id: 'within', label: 'отклонение от master ≤ 1%', ok: true },
    ],
    usedIn: [{ id: 'r6', name: 'Валовая прибыль' }],
  },
  r5: {
    id: 'r5', name: 'Себестоимость реализованных товаров и услуг', level: 0,
    description: 'Себестоимость по основной деятельности. Включает сырьё, ФОТ производства, амортизацию.',
    sources: [
      { file: '7111', cell: 'D210', label: 'Сырьё и материалы', preview: 84200000 },
      { file: '7111', cell: 'D211', label: 'ФОТ производства',  preview: 28100000 },
      { file: '7111', cell: 'D212', label: 'Амортизация ОС',    preview: 6420000 },
    ],
    masterMapping: { sheet: 'СГД', cell: 'B16', label: 'Себестоимость' },
    preview: { dd: 118720000, sd: 99300000, kl: 71800000, ki: 84200000, dk: 51400000, cn: 22100000 },
    validationRules: [
      { id: 'nonneg', label: 'значение ≥ 0', ok: true },
      { id: 'within', label: 'отклонение от master ≤ 1%', ok: false, msg: 'dd: 1.4% · превышен порог' },
      { id: 'sign', label: 'знак: расход (+)', ok: true },
    ],
    usedIn: [{ id: 'r6', name: 'Валовая прибыль' }],
  },
  r6: {
    id: 'r6', name: 'Валовая прибыль', level: 0, isTotal: true,
    description: 'Итоговая строка. r4 − r5.',
    sources: [
      { file: '↩ ref', cell: 'r4', label: 'ИТОГО СГД',     preview: 183380315 },
      { file: '↩ ref', cell: 'r5', label: 'Себестоимость', preview: 118720000 },
    ],
    masterMapping: { sheet: 'СГД', cell: 'B17', label: 'Валовая прибыль' },
    preview: { dd: 64660315, sd: 57120000, kl: 20600000, ki: 24100000, dk: 24800000, cn: 24900000 },
    validationRules: [
      { id: 'sum', label: 'r4 − r5 = валовая прибыль', ok: true },
      { id: 'margin', label: 'маржа > 10%', ok: true, msg: 'dd: 35.3%' },
    ],
    usedIn: [],
  },
  r7: {
    id: 'r7', name: 'Заработная плата АУП', level: 0,
    description: 'ФОТ административно-управленческого персонала.',
    sources: [
      { file: '7470', cell: 'C12', label: 'Оклады АУП',      preview: 8400000 },
      { file: '7470', cell: 'C13', label: 'Премии и бонусы', preview: 1620000 },
    ],
    masterMapping: { sheet: 'Адм. расходы', cell: 'D5', label: 'ЗП АУП' },
    preview: { dd: 10020000, sd: 8400000, kl: 4200000, ki: 5100000, dk: 3800000, cn: 2400000 },
    validationRules: [
      { id: 'nonneg', label: 'значение ≥ 0', ok: true },
      { id: 'within', label: 'отклонение от master ≤ 1%', ok: true },
    ],
    usedIn: [],
  },
  r8: {
    id: 'r8', name: 'Социальный налог и отчисления', level: 0,
    description: 'Социальный налог, ОСМС, ОПВ от ФОТ АУП.',
    sources: [{ file: '7470', cell: 'C14', label: 'Соц. налог + отчисления', preview: 2104200 }],
    masterMapping: { sheet: 'Адм. расходы', cell: 'D6', label: 'Соц. налог' },
    preview: { dd: 2104200, sd: 1764000, kl: 882000, ki: 1071000, dk: 798000, cn: 504000 },
    validationRules: [
      { id: 'nonneg', label: 'значение ≥ 0', ok: true },
      { id: 'pct', label: '≈ 21% от r7', ok: true, msg: 'dd: 21.0%' },
    ],
    usedIn: [],
  },
  r9: {
    id: 'r9', name: 'Аренда офиса', level: 0,
    description: 'Аренда административных помещений.',
    sources: [{ file: '7470', cell: 'C18', label: 'Аренда офиса', preview: 4800000 }],
    masterMapping: { sheet: 'Адм. расходы', cell: 'D8', label: 'Аренда офиса' },
    preview: { dd: 4800000, sd: 3600000, kl: 1800000, ki: 2400000, dk: 1200000, cn: 1800000 },
    validationRules: [
      { id: 'nonneg', label: 'значение ≥ 0', ok: true },
      { id: 'within', label: 'отклонение от master ≤ 1%', ok: true },
    ],
    usedIn: [],
  },
};

export const CELL_PREVIEWS: Record<string, CellPreview> = {
  '7211_E175': { file: '7211', sheet: 'Продажи 2026', cell: 'E175', label: 'Производство · реализация',
    grid: [
      ['', 'C', 'D', 'E', 'F'],
      ['174', 'январь',  '38 100 000', '40 200 000', '41 882 000'],
      ['175', 'итого Q1', '110 400 000', '118 600 000', '124 182 000'],
      ['176', 'импорт',   '34 100 000', '36 200 000', '38 420 000'],
    ], hl: { r: 2, c: 4 } },
  '7211_E176': { file: '7211', sheet: 'Продажи 2026', cell: 'E176', label: 'Импорт · перепродажа',
    grid: [
      ['', 'C', 'D', 'E', 'F'],
      ['175', 'итого Q1', '110 400 000', '118 600 000', '124 182 000'],
      ['176', 'импорт',   '34 100 000', '36 200 000', '38 420 000'],
      ['177', 'услуги',   '3 800 000', '3 900 000', '4 118 000'],
    ], hl: { r: 2, c: 4 } },
  '7211_E177': { file: '7211', sheet: 'Продажи 2026', cell: 'E177', label: 'Прочие услуги',
    grid: [
      ['', 'C', 'D', 'E', 'F'],
      ['176', 'импорт',   '34 100 000', '36 200 000', '38 420 000'],
      ['177', 'услуги',   '3 800 000', '3 900 000', '4 118 000'],
      ['178', 'итого',    '148 300 000', '158 700 000', '166 720 000'],
    ], hl: { r: 2, c: 4 } },
  'osv_F412': { file: 'osv', sheet: 'ОСВ Q1', cell: 'F412', label: 'Переоценка ОС',
    grid: [
      ['', 'D', 'E', 'F'],
      ['411', '2410', '128 400 000', '1 840 000'],
      ['412', '2411', '128 400 000', '1 840 000'],
      ['413', '2420', '0', '0'],
    ], hl: { r: 2, c: 3 } },
  'osv_F438': { file: 'osv', sheet: 'ОСВ Q1', cell: 'F438', label: 'Курсовая разница',
    grid: [
      ['', 'D', 'E', 'F'],
      ['437', '6280',  '0', '12 420 315'],
      ['438', '6280.1', '0', '12 420 315'],
      ['439', '6290',  '0', '0'],
    ], hl: { r: 2, c: 3 } },
  'osv_F441': { file: 'osv', sheet: 'ОСВ Q1', cell: 'F441', label: 'Списание кред. задолженности',
    grid: [
      ['', 'D', 'E', 'F'],
      ['440', '6290',  '0', '0'],
      ['441', '6290.5', '0', '2 400 000'],
      ['442', '7010',  '0', '0'],
    ], hl: { r: 2, c: 3 } },
  '7111_D210': { file: '7111', sheet: 'Себестоимость', cell: 'D210', label: 'Сырьё и материалы',
    grid: [
      ['', 'B', 'C', 'D'],
      ['209', 'Q4 2025',   '78 200 000', '82 100 000'],
      ['210', 'Q1 2026',  '80 100 000', '84 200 000'],
      ['211', 'ФОТ произ-ва', '26 200 000', '28 100 000'],
    ], hl: { r: 2, c: 3 } },
  '7111_D211': { file: '7111', sheet: 'Себестоимость', cell: 'D211', label: 'ФОТ производства',
    grid: [
      ['', 'B', 'C', 'D'],
      ['210', 'Q1 2026',  '80 100 000', '84 200 000'],
      ['211', 'ФОТ произ-ва', '26 200 000', '28 100 000'],
      ['212', 'Аморт. ОС',    '5 800 000', '6 420 000'],
    ], hl: { r: 2, c: 3 } },
  '7111_D212': { file: '7111', sheet: 'Себестоимость', cell: 'D212', label: 'Амортизация ОС',
    grid: [
      ['', 'B', 'C', 'D'],
      ['211', 'ФОТ произ-ва', '26 200 000', '28 100 000'],
      ['212', 'Аморт. ОС',    '5 800 000', '6 420 000'],
      ['213', 'итого',        '112 100 000', '118 720 000'],
    ], hl: { r: 2, c: 3 } },
  '7470_C12': { file: '7470', sheet: 'Адм. расходы', cell: 'C12', label: 'Оклады АУП',
    grid: [
      ['', 'A', 'B', 'C'],
      ['11', 'фев', 'Оклады АУП', '8 200 000'],
      ['12', 'мар', 'Оклады АУП', '8 400 000'],
      ['13', 'мар', 'Премии',     '1 620 000'],
    ], hl: { r: 2, c: 3 } },
  '7470_C13': { file: '7470', sheet: 'Адм. расходы', cell: 'C13', label: 'Премии и бонусы',
    grid: [
      ['', 'A', 'B', 'C'],
      ['12', 'мар', 'Оклады АУП', '8 400 000'],
      ['13', 'мар', 'Премии',     '1 620 000'],
      ['14', 'мар', 'Соц. налог', '2 104 200'],
    ], hl: { r: 2, c: 3 } },
  '7470_C14': { file: '7470', sheet: 'Адм. расходы', cell: 'C14', label: 'Соц. налог',
    grid: [
      ['', 'A', 'B', 'C'],
      ['13', 'мар', 'Премии',     '1 620 000'],
      ['14', 'мар', 'Соц. налог', '2 104 200'],
      ['15', 'мар', 'ОСМС',       '0'],
    ], hl: { r: 2, c: 3 } },
  '7470_C18': { file: '7470', sheet: 'Адм. расходы', cell: 'C18', label: 'Аренда офиса',
    grid: [
      ['', 'A', 'B', 'C'],
      ['17', 'мар', 'Связь',       '420 000'],
      ['18', 'мар', 'Аренда офиса', '4 800 000'],
      ['19', 'мар', 'Канцтовары',  '180 000'],
    ], hl: { r: 2, c: 3 } },
};

export const COMPANIES_LITE = [
  { id: 'dd', short: 'DD', name: 'Delta Doors' },
  { id: 'sd', short: 'SD', name: 'Senim Doors' },
  { id: 'kl', short: 'KL', name: 'Kendala Logistics' },
  { id: 'ki', short: 'KI', name: 'Kendala Impex' },
  { id: 'dk', short: 'DK', name: 'Двери.Класс' },
  { id: 'cn', short: 'CN', name: 'ЦН недвижимость' },
];
